import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { TTotalProps } from './types';

const multiplySymbol = '\u00D7';

export const Total: FC<TTotalProps> = ({ totalPerItem, quantity, totalCost, paymentCurrency }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
				gap: 4,
				ml: 4,
				mb: 2,
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					gap: 1,
				}}
			>
				{/* <Typography variant="body1">Total</Typography> */}
			</Box>

			<Box
				sx={{
					display: 'flex',
					gap: 1,
				}}
			>
				{/* <Typography
					variant="body1"
					sx={{
						fontSize: '.8rem',
					}}
					color="text.secondary"
				>
					{totalPerItem?.toFixed(2)}{' '}
					<span
						style={{
							fontSize: '.7rem',
							color: '#00000080',
							fontWeight: 'normal',
						}}
					>
						{paymentCurrency}
					</span>{' '}
					{multiplySymbol} {quantity} ={' '}
				</Typography> */}
				<AmountAndCurrency amount={totalCost ?? 0} currency={paymentCurrency} bold size={1} />
			</Box>
		</Box>
	);
};
